import { _api } from '@/utils/apiAxios';
import { slugify } from '@/utils/common';
const socket = require('@/utils/casinoSignalR').socket;
import { log } from '@/utils/logging';
import { FAVORITE_LS_KEY, favoriteMenuItem, getFavoriteGamesFromLS } from '../../../utils/casino-utils';

let tryConnectInterval;
let isTryConnect = false;
let isTryToConnect = false;

const state = {
  status: { loading: false },
  menuList: [],
  bonus: [],
  activeMenu: {},
  activeNav: {},
  activeLeagueId: 0,
  browserIsIdle: false,
  casinoDescriptions: [],
  casinoFavItems: getFavoriteGamesFromLS() || [],
  searchModalOpened: false,
  showGoDepositModal: false,
  selectedCasinoBonusId: null,
  isOpenGame: false,
  isPlayTechGame: false,
};
const mutations = {
  initializing: (state, val) => {
    state.status = { loading: val };
  },
  setSelectedCasinoBonusId: (state, data) => {
    state.selectedCasinoBonusId = data;
  },
  isOpenGame: (state, data) => {
    state.isOpenGame = data;
  },
  setCasinoDescriptions: (state, data) => {
    state.casinoDescriptions = data;
  },
  setShowGoDepositModal: (state, data) => {
    state.showGoDepositModal = data;
  },
  setMenuList: (state, data) => {
    state.menuList = data;
  },
  setBonus: (state, data) => {
    state.bonus = data;
  },
  setActiveMenu: (state, menu) => {
    state.activeMenu = menu;
  },
  setActiveLeague: (state, menu) => {
    state.activeLeagueId = menu;
    // router.push("/sports");
  },
  setActiveNav: (state, nav) => {
    state.activeNav = nav;
  },
  addCasinoFavItem: (state, game) => {
    let games = state.casinoFavItems;

    const menuList = state.menuList;

    const isFound = games.find(g => g.display_name === game.display_name);

    if (isFound) {
      games = games.filter(g => g.display_name !== game.display_name);
    } else {
      games = [...games, game];
    }

    localStorage.setItem(FAVORITE_LS_KEY, JSON.stringify(games));
    state.casinoFavItems = games;
    state.menuList = menuList.map(menu => (menu.icon === 'favorites-menu' ? { ...menu, games } : menu));
  },
  setSearchModalOpened(state, value) {
    state.searchModalOpened = value;
  },
  isPlayTechGame: (state, data) => {
    state.isPlayTechGame = data;
  },
};
const getters = {
  isFavoriteGame: state => game => {
    return !!state.casinoFavItems.find(fav => fav.display_name === game.display_name);
  },
};
const actions = {
  getMenuList: ({ commit, dispatch, rootState, state }, param) => {
    commit('initializing', true);
    dispatch('connectSocket');
    const token = localStorage.getItem('epos_token');
    //{ DESKTOP_PLATFORM = 1, ANDROID_PLATFORM = 2, WINDOWS_PHONE_PLATFORM = 3, MOBILE_PLATFORM = 4 }
    if (token) {
      const isMobile = /iphone|ipod|ipad|android|blackberry|opera mini|opera mobi|skyfire|maemo|windows phone|palm|iemobile|symbian|symbianos|fennec/i.test(
        window.navigator.userAgent.toLowerCase(),
      );
      _api
        .get(`/casino/lobby?platformType=${isMobile ? 4 : 1}`, {
          headers: { 'epos-token': token },
        })
        .then(res => {
          let renderList = res.data.Data.menuList;
          if (res.data.Data.bonus !== null) {
            renderList.push({
              id: 0,
              display_name: 'Bonus',
              image: '',
              posiiton: 0,
              isActive: true,
              icon: 'bonuses',
              most_played_games: [],
              games: res.data.Data.bonus.games ? res.data.Data.bonus.games : '',
            });
          }
          renderList = [...renderList, favoriteMenuItem(rootState.casinoMenu.casinoFavItems)];
          if (res.data.Data.bonus) {
            var bonus = res.data.Data.bonus;
            commit('setBonus', bonus);
          }
          commit('setMenuList', renderList);
          let active = param ? renderList.find(r => slugify(r.display_name) === param) || renderList[0] : renderList[0];
          dispatch('setActiveMenu', active);
          commit('initializing', false);
        });
    }
  },
  getGameDescriptions: ({ commit, rootState }) => {
    _api
      .get(
        rootState.settings.brandSettings.cms_site_url +
          '/wp-json/cms-request/v1/get-casino-game-infos/' +
          rootState.settings.selectedLocale.short_code,
      )
      .then(res => {
        commit('setCasinoDescriptions', res.data);
      })
      .catch(err => {
        commit('setCasinoDescriptions', []);
      });
  },

  getBonusMenu: ({}, menu) => {},
  setActiveMenu: ({ commit, dispatch }, menu) => {
    commit('setActiveMenu', menu);
    commit('setActiveLeague', menu);
  },
  setActiveLeague: ({ commit, dispatch }, leagueId) => {
    commit('setActiveLeague', leagueId);
  },
  setActiveNav: ({ commit }, nav) => {
    commit('setActiveNav', nav);
  },
  connectSocket: ({ commit, rootState, dispatch, state }) => {
    if (!rootState.settings.brandSettings.socket_is_active) return;
    if (state.browserIsIdle) return;
    if (socket.connectionStates.connected === rootState.settings.casinoSocketConnection) {
      clearInterval(tryConnectInterval);
      isTryToConnect = false;
      return;
    }

    log('[CASINO_SOCKET] trying to connect socket');

    rootState.settings.casinoSocketConnection = socket.connectionStates.connecting;
    socket._casinoSignalR
      .connect(() => {
        rootState.settings.casinoSocketConnection = socket.connectionStates.disconnected;
        if (state.browserIsIdle) return;
        if (!isTryToConnect) {
          tryConnectInterval = setInterval(() => {
            //if socket is down
          }, rootState.settings.brandSettings.socket_fail_interval);
          isTryToConnect = true;
        }
      })
      .then(res => {
        log('[CASINO_SOCKET] socket connected');
        rootState.settings.casinoSocketConnection = socket.connectionStates.connected;
        // listen to spesific line type for odds changes
        // socket._casinoSignalR.invoke("SubscribeToLineType", rootState.settings.terminalInfo.id_line_type);

        socket._casinoSignalR.subscribe('LobbyStatus', args => {
          const res = args;
          dispatch('setLobbyStatusData', res);
        });
        socket._casinoSignalR.subscribe('SeatStatusUpdate', args => {
          const res = args;
          dispatch('setSeatStatusData', res);
        });
        socket._casinoSignalR.subscribe('SeatStatusFull', args => {
          const res = args;
          dispatch('setSeatStatusFullData', res);
        });

        var hasEndMatch = false;
      })
      .catch(() => {
        if (!isTryToConnect) {
          rootState.settings.socketConnection = socket.connectionStates.disconnected;
          tryConnectInterval = setInterval(() => {
            //if socket is down
          }, rootState.settings.brandSettings.socket_fail_interval);
          isTryToConnect = true;
          log('[CASINO_SOCKET] socket connect failed');
        }
      });
  },
  disconnectSocket: () => {
    log('[CASINO_SOCKET] socket disconnect called');
    socket._casinoSignalR.disconnect();
  },
  setSeatStatusFullData({ commit, rootState, state, dispatch }, data) {
    const dd = state.menuList.map(item => {
      if (item.icon === 'live') {
        item.games.map(game => {
          var zz = data[game.providerGameId];
          if (zz === undefined) {
            return game;
          }
          var aa = zz.filter(f => f.table === parseInt(game.urlValues.replace('table=', '')));
          if (aa && aa.length > 0) {
            if (game.dealer && game.dealer.url) {
              aa[0].dealer['url'] = game.dealer.url;
            }
            game['dealer'] = aa[0].dealer;
            game['seats'] = aa[0].seats;
            if (aa[0].limits) game['limits'] = aa[0].limits;
          }
          return game;
        });
      }
      return item;
    });
    commit('setMenuList', dd);
  },
  setSeatStatusData({ commit, rootState, state, dispatch }, data) {
    const dd = state.menuList.map(item => {
      if (item.icon === 'live') {
        item.games.map(game => {
          var zz = data[game.providerGameId];
          if (zz === undefined) {
            return game;
          }
          var aa = zz.filter(f => f.table === parseInt(game.urlValues.replace('table=', '')));
          if (aa && aa.length > 0) {
            if (game.dealer && game.dealer.url) {
              aa[0].dealer['url'] = game.dealer.url;
            }
            game['dealer'] = aa[0].dealer;
            game['seats'] = aa[0].seats;
            if (aa[0].limits) game['limits'] = aa[0].limits;
          }
          return game;
        });
      }
      return item;
    });
    commit('setMenuList', dd);
  },
  setLobbyStatusData({ commit, rootState, state, dispatch }, data) {
    const dd = state.menuList.map(item => {
      if (item.icon === 'live') {
        item.games.map(game => {
          var zz = data[game.providerGameId];
          if (zz === undefined) {
            return game;
          }
          var aa = zz.filter(f => f.table === parseInt(game.urlValues.replace('table=', '')));
          if (aa && aa.length > 0) {
            game['dealer'] = aa[0].dealer;
            game['seats'] = aa[0].seats;
            if (aa[0].limits) game['limits'] = aa[0].limits;
          }
          return game;
        });
      }
      return item;
    });
    commit('setMenuList', dd);
  },
};

export const casinoMenu = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
